// Configuración del módulo de tablero de delegados.
// Todo lo que depende del proyecto/backend está aquí para facilitar la migración.

// Rol que puede usar el tablero (1 = delegado/técnico)
export const DELEGATE_ROLES = [1];

// Rutas del módulo
export const DELEGATE_PATH = "/delegate";
export const delegateBoardPath = (gamecode) => `${DELEGATE_PATH}/${gamecode}`;

// Estados de partido que se listan al delegado
// 1 = programado, 5 = primer tiempo, 6 = entretiempo, 7 = segundo tiempo
export const LISTED_GAME_STATUS = [1, 5, 6, 7];
export const LIVE_GAME_STATUS = [5, 6, 7];
export const HALFTIME_STATUS = 6;
export const SECOND_HALF_STATUS = 7;
export const HALFTIME_MINUTE = 41;
export const SECOND_HALF_OFFSET = 40;

// Parámetros de consulta de partidos del equipo (mismos que usa el calendario por equipo)
export const GAMES_QUERY = {
  championshipcode: 5,
  maxDate: "2024-01-20",
  orderby: "asc",
};

// Códigos de evento de la planilla
export const EVENT = {
  STARTER: 22, // titular
  LATE_IN: 25, // ingreso post inicio
  SUB_IN: 8, // entra por sustitución
  SUB_OUT: 23, // sale por sustitución
  PRESENCE: 15, // presencia (no juega)
};
export const LINEUP_EVENTS = [15, 22, 8, 25, 23];

// Máximo de jugadores en campo
export const MAX_IN_FIELD = 11;

// Mínimo en campo para iniciar el partido: desde aquí se habilitan sustituciones
export const MIN_TO_START = 7;

// Prefijo de almacenamiento local (por partido y equipo)
export const STORAGE_PREFIX = "delegateBoard";

// Link del menú lateral para el rol delegado
export const delegateLinks = [
  {
    title: "Mi tablero de partido (BETA)",
    path: DELEGATE_PATH,
  },
];

// Colores de carnet (mismos de la planilla en el borde de la foto)
export const CARNET = {
  goal: { label: "Arquero", short: "ARQ", color: "var(--widget-dark)", text: "#fff" },
  young: { label: "Amarillo", short: "32-34", color: "var(--accent)", text: "#111" },
  middle: { label: "Verde", short: "35-39", color: "var(--green)", text: "#fff" },
  old: { label: "Rojo", short: "40-44", color: "var(--red)", text: "#fff" },
  oldMore: { label: "Azul", short: "45-49", color: "var(--blue)", text: "#fff" },
  tooOld: { label: "Plateado", short: "50+", color: "#A7ACB1", text: "#111" },
};

// Carnet según el campo media del jugador
export const MEDIA_TO_CARNET = {
  goalkeeper: "goal",
  young: "young",
  middle: "middle",
  old: "old",
  old_more: "oldMore",
  too_old: "tooOld",
};

// Pestañas del tablero (vista celular)
export const TABS = [
  { key: "field", label: "Campo" },
  { key: "roster", label: "Plantilla" },
  { key: "moves", label: "Movimientos" },
  { key: "cards", label: "Tarjetas" },
];
